import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useActiveSession } from "@/hooks/useActiveSession";
import type { SessionRecord } from "@/hooks/useSessions";

interface StartSessionButtonProps {
  session: SessionRecord;
  size?: "sm" | "default" | "lg" | "icon";
  variant?: "default" | "ghost" | "outline";
  className?: string;
  label?: string;
}

export function StartSessionButton({
  session,
  size = "sm",
  variant = "ghost",
  className,
  label = "Démarrer",
}: StartSessionButtonProps) {
  const { startSession, session: activeSession, openOverlay } = useActiveSession();

  const isThisActive = activeSession?.id === session.id;

  const handleClick = () => {
    if (isThisActive) {
      openOverlay();
    } else {
      startSession(session);
    }
  };

  return (
    <Button size={size} variant={isThisActive ? "default" : variant} className={className} onClick={handleClick}>
      <Play className="h-3 w-3 mr-1" />
      {isThisActive ? "Reprendre" : label}
    </Button>
  );
}
